unit UUtils;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.Controls, WEBLib.Grids,
  WEBLib.ExtCtrls, WEBLib.WebCtrls, Web, JS, XData.Web.Client,
  UDadosUsuarioVO,
  UWeb.Enum,
  System.StrUtils,
  XData.Web.Dataset,
  WEBLib.DBCtrls,
  System.Generics.Collections,
  UPersonalizacao_Tabela.Interfaces;

type
  TTipoDialogo = (SUCESSO, ERROR, INFORMACAO, CONFIRMACAO);

  TUtils = class
    const
      FTempoTimerConsulta = 800;
      FServidoresDisponiveis : array[0..2] of String = ('Service', 'Mensagens', 'WhatsApp');

    class var FErroNaoAutorizado : Boolean;
    class var FUsuario : TDadosUsuarioVO;
    class var FDicionarioPermissoes : TDictionary<string, TJSObject>;
    class var FDicionarioClassesHtml : TDictionary<string,string>;
    class var FInstanciaPersonalizacaoTabela : IPersonalizacao_Tabela;

    class function FormatarCnpj(pNumero: string): string;
    class function FormatarCpf(pNumero: string): string;
    class function FormatarCnpj_Cpf(pNumero: string): string;
    class function FormatarCEP(const pCEP: string): string;
    class function FormatarTelefone(const pTelefone: string): string;
    class function GetNomeStatusAliado(pValor : Integer) : string;
    class function GetNomeStatusProduto(pValor : Integer) : string;
    class function GetPrecoPadraoProduto(pValor : Integer) : string;
    class procedure OcultarDivLoading;
    class procedure ChamarDivLoading(pMensagem : string = '');
    class procedure SetMensagemDivLoading(pMensagem: string);
    class procedure OcultarElemento(pElementoId : string);
    class procedure MostrarElemento(pElementoId : string);
    class procedure OpenModal(pId : string);
    class procedure CloseModal(pId : string);
    class function GetExtensaoArquivo(pArquivo : string) : string;
    class function IsPerfilFacilSistemas(pUsuario : TDadosUsuarioVO; pVerificarAliado : Boolean = False) : Boolean;
    class function IsPerfilAliado(pUsuario : TDadosUsuarioVO) : Boolean;
    class function IsPerfilParceiro(pUsuario : TDadosUsuarioVO; pVerificarAliado : Boolean = False) : Boolean;
    class procedure SetErroClass(pClass, pErro : string);
    class procedure RemoverErroClass(pClass : string);
    class procedure LimparErrosClass;
    [async]
    class function ChamarMensagemDialog(pTipo : TTipoDialogo; pMensagem : string) : Boolean; async;
    class function ValidarEmail(pEmail: string): Boolean;
    class function SomenteNumeros(const pTexto: string): string;
    class function GetTokenNome(pServidor : TServidor) : string;
    class function VerificarAcessoServidor(pServidor : TServidor; pPerfilAcesso : string) : Boolean;
    class function GetCodigoServidor(pServidor : TServidor) : string;
    class procedure ExportarDadosExcel(pCds : TXDataWebDataSet; pTabela : TDBTableControl;
      pFiltro : string; pQuantidadeRegistros : Integer = 0);
    class procedure RemoverMenusVazios;
    class procedure CarregarPermissoes(pArray : TJSArray; pPerfil : Integer);
    class procedure RemoverElementoPorId(pId : string);
    class function PossuiPermissao(pTabela : string; pPermissao : TTipoPermissao) : Boolean;
    class procedure BloquearCamposDiv(const pDivId: string; pIncluirBotoes: Boolean = False);
    class procedure DesbloquearCamposDiv(const pDivId: string; pIncluirBotoes: Boolean = False);
    class procedure ControlarSelect(const pSelectId, pTexto: string; pDisable: Boolean);
    class function BloquearAcessoMenuDashboard(pTabela: string): Boolean;
    class procedure SetPaginaSelecionada;
    class procedure SetValorDicionarioClasses(pChave, pValor : string);
    class function FormatarMesAno(pValor : string) : string;
    class function FormatarNumeroInteiro(pValor : Integer) : string;
    class function GetIndexColunaPeloTitulo(pTabela : TDBTableControl; pTitulo : string): Integer;
    class function GetNomeStatusCliente(pValor : Integer) : string;
    class function FormatarCidadeEstado(pCidade, pEstado : string) : string;
    class function GetNomeStatusFornecedor(pValor : Integer) : string;
    class procedure SelecionarTab(pIdentificador : string);
  end;

implementation

uses
  View.Dialog,
  UExportacoes;

{ TUtils }

class function TUtils.BloquearAcessoMenuDashboard(pTabela: string): Boolean;
begin
  Result := not PossuiPermissao(pTabela, TTipoPermissao.VISUALIZAR);

  if Result then
  begin
    ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Usuário sem permissão para visualizar ' +
      'dados de ' + pTabela + '!');
  end;
end;

class procedure TUtils.BloquearCamposDiv(const pDivId: string; pIncluirBotoes: Boolean);
begin
  asm
    var div = document.getElementById(pDivId);

    if (div) {
      var fieldsets = div.querySelectorAll('fieldset');
    fieldsets.forEach(function(fs) { fs.disabled = true; });

      var seletor = 'input, select, textarea';
      if (pIncluirBotoes) seletor += ', button';
      var elementos = div.querySelectorAll(seletor);

      elementos.forEach(function(el) {
        if (!el.classList.contains('nao-desabilitar')) {
          el.disabled = true;
          el.classList.add('disabled'); // opcional: para estilo visual
        }
      });
    }
  end;
end;

class procedure TUtils.CarregarPermissoes(pArray : TJSArray; pPerfil : Integer);
var
  lJsonObject: TJSObject;
  lIndice : Integer;
begin
  if not Assigned(FDicionarioPermissoes) then
    FDicionarioPermissoes := TDictionary<string, TJSObject>.Create
  else
    FDicionarioPermissoes.Clear;

  for lIndice := 0 to pArray.Length - 1 do
  begin
    lJsonObject := TJSObject(pArray[lIndice]);

    if not StrtoBool(string(lJsonObject['visualizar'])) then
      RemoverElementoPorId(string(lJsonObject['tabela']));

    FDicionarioPermissoes.Add(string(lJsonObject['tabela']), lJsonObject);
  end;


  if pPerfil <> 1 then
    RemoverElementoPorId('fs_prod_produtos');

  if PossuiPermissao('produtos_associacao', TTipoPermissao.VISUALIZAR) and not
    PossuiPermissao('produtos', TTipoPermissao.VISUALIZAR) then
  begin
    RemoverElementoPorId('produtos_associacao');
  end;

  RemoverMenusVazios;
end;

class procedure TUtils.ChamarDivLoading(pMensagem: string);
begin
  if pMensagem = '' then
    OcultarElemento('mensagem_loading')
  else
  begin
    SetMensagemDivLoading(pMensagem);
    MostrarElemento('mensagem_loading');
  end;

  asm
    var div = document.getElementById("gif-loading");
    div.style.display = "flex";
  end;
end;

class function TUtils.ChamarMensagemDialog(pTipo: TTipoDialogo;
  pMensagem: string): Boolean;
var
  Dialog: TDialog;
begin
  if FErroNaoAutorizado then
    Exit;

  FErroNaoAutorizado := Pos('O tempo de conexão expirou', pMensagem) > 0;

  TUtils.OcultarDivLoading;

  Dialog := TDialog.Create(nil);
  try
    Dialog.Caption := 'Child form';
    Dialog.Popup := True;
    Dialog.PopupOpacity := 0.2;
    Dialog.FTipo := pTipo;
    Dialog.FMensagem := pMensagem;
    Dialog.Width := 400;
    Dialog.Height := 300;
    //window.location.hash := 'subform';

    Await(TDialog, Dialog.Load());
    Await(TModalResult, Dialog.Execute);
  finally
    Result := Dialog.FResult;
    Dialog.Free;
  end;
end;

class procedure TUtils.CloseModal(pId: string);
begin
  asm
    $('#' + pId).modal('hide');
  end;
end;

class procedure TUtils.ControlarSelect(const pSelectId, pTexto: string;
  pDisable: Boolean);
begin
  asm
    var sel = document.getElementById(pSelectId);
    if (!sel) return;
    for (var i = 0; i < sel.options.length; i++) {
      if (sel.options[i].text === pTexto) {
        sel.options[i].disabled = pDisable;
        // Se estiver selecionado, limpa a seleção
        if (pDisable && sel.options[i].selected)
          sel.selectedIndex = -1;
        break;
      }
    }
  end;
end;

class procedure TUtils.DesbloquearCamposDiv(const pDivId: string;
  pIncluirBotoes: Boolean);
begin
  asm
    var div = document.getElementById(pDivId);

    if (div) {
      var fieldsets = div.querySelectorAll('fieldset');
      fieldsets.forEach(function(fs) { fs.disabled = false; });

      var seletor = 'input, select, textarea';
      if (pIncluirBotoes) seletor += ', button';
      var elementos = div.querySelectorAll(seletor);

      elementos.forEach(function(el) {
        if (!el.classList.contains('nao-habilitar')) { // opcional, análogo à 'nao-desabilitar'
          el.disabled = false;
          el.classList.remove('disabled'); // remove classe visual
        }
      });
    }
  end;
end;

class procedure TUtils.ExportarDadosExcel(pCds: TXDataWebDataSet;
  pTabela: TDBTableControl; pFiltro: string; pQuantidadeRegistros: Integer);
var
  lExportacoes : TExportacoes;
begin
  if pCds.RecordCount <= 0 then
    ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Não existem dados para serem exportados!')
  else
  begin
    lExportacoes := TExportacoes.Create(pCds, pTabela);
    lExportacoes.ExportarExcel(pFiltro, pQuantidadeRegistros);
  end;
end;

class function TUtils.FormatarCEP(const pCEP: string): string;
begin
  Result := Trim(pCEP);
  Result := StringReplace(Result, '.', '', [rfReplaceAll]);
  Result := StringReplace(Result, '-', '', [rfReplaceAll]);
  if Length(Result) = 8 then
    Result := Copy(Result, 1, 5) + '-' + Copy(Result, 6, 3);
end;

class function TUtils.FormatarCidadeEstado(pCidade, pEstado: string): string;
begin
  Result := EmptyStr;

  if not(pCidade.IsEmpty) and not pEstado.IsEmpty then
    Result := UpperCase(pCidade + ' - ' + pEstado)
  else if not(pCidade.IsEmpty) then
    Result := UpperCase(pCidade);
end;

class function TUtils.FormatarCnpj(pNumero: string): string;
var
  lTemp,
  lResultado: String;
  lIndex: integer;
begin
  if Length(pNumero) < 12 Then
  begin
    Result := '';
    Exit;
  end;

  for lIndex := 1 to Length(pNumero) do
  begin
    if pNumero[lIndex] in ['0'..'9'] Then
      lResultado := lResultado + pNumero[lIndex];
  end;

  if Length(lResultado) < 14 Then
    lResultado := StringOfChar('0', 14 - Length(lResultado)) + lResultado;

  lTemp := Copy(lResultado,1,2) + '.';
  lTemp := lTemp + Copy(lResultado,3,3) + '.';
  lTemp := lTemp + Copy(lResultado,6,3) + '/';
  lTemp := lTemp + Copy(lResultado,9,4) + '-' + Copy(lResultado,13,2);

  Result := lTemp;
end;

class function TUtils.FormatarCnpj_Cpf(pNumero: string): string;
var
  lIndex : integer;
  lResultado: String;
begin
  for lIndex := 1 to Length(pNumero) do
  begin
    if pNumero[lIndex] in ['0'..'9'] Then
      lResultado := lResultado + pNumero[lIndex];
  end;

  if (Length(lResultado) > 11) Then
    lResultado := FormatarCnpj(lResultado)
  else
    lResultado := FormatarCpf(lResultado);

  Result := lResultado;
end;


class function TUtils.FormatarCpf(pNumero: string): string;
var
  lTemp,
  lResultado: String;
  lIndex: integer;
begin
  if Length(pNumero) < 10 Then
  begin
    Result := '';
    Exit;
  end;

  for lIndex := 1 to Length(pNumero) do
  begin
    if pNumero[lIndex] in ['0'..'9'] Then
      lResultado := lResultado + pNumero[lIndex];
  end;

  if Length(lResultado) < 11 Then
    lResultado := StringOfChar('0', 11 - Length(lResultado)) + lResultado;

  lTemp := Copy(lResultado,1,3) + '.';
  lTemp := lTemp + Copy(lResultado,4,3) + '.';
  lTemp := lTemp + Copy(lResultado,7,3) + '-';
  lTemp := lTemp + Copy(lResultado,10,2);
  Result := lTemp;
end;

class function TUtils.FormatarMesAno(pValor: string): string;
var
  lMes,
  lAno: string;
begin
  lMes := Copy(pValor, 1, Pos('/', pValor) - 1);
  lAno := Copy(pValor, Pos('/', pValor) + 1, Length(pValor));

  Result := Format('%.2d/%s', [StrToInt(lMes), lAno]);
end;

class function TUtils.FormatarNumeroInteiro(pValor: Integer): string;
var
  lMyFormatSettings: TFormatSettings;
begin
  lMyFormatSettings := TFormatSettings.Create;
  lMyFormatSettings.ThousandSeparator := '.';
  lMyFormatSettings.DecimalSeparator := ',';

  Result := FormatFloat('#,##0', pValor, lMyFormatSettings);
end;

class function TUtils.FormatarTelefone(const pTelefone: string): string;
var
  lNum: string;
begin
  lNum := pTelefone;
  lNum := StringReplace(lNum, '(', '', [rfReplaceAll]);
  lNum := StringReplace(lNum, ')', '', [rfReplaceAll]);
  lNum := StringReplace(lNum, '-', '', [rfReplaceAll]);
  lNum := StringReplace(lNum, ' ', '', [rfReplaceAll]);

  // Aplica a formatação com base no tamanho
  if Length(lNum) = 10 then
    Result := '(' + Copy(lNum, 1, 2) + ') ' + Copy(lNum, 3, 4) + '-' + Copy(lNum, 7, 4)
  else if Length(lNum) = 11 then
    Result := '(' + Copy(lNum, 1, 2) + ') ' + Copy(lNum, 3, 5) + '-' + Copy(lNum, 8, 4)
  else
    Result := pTelefone; // Retorna o original se o tamanho for inválido
end;

class function TUtils.GetCodigoServidor(pServidor: TServidor): string;
begin
  case pServidor of
    SERVICE: Result := '1';
    MENSAGENS: Result := '2';
    WHATSAPP: Result := '3';
  end;
end;

class function TUtils.GetExtensaoArquivo(pArquivo: string): string;
begin
  Result := ExtractFileExt(pArquivo);
  Delete(Result, 1, 1);
end;

class function TUtils.GetIndexColunaPeloTitulo(pTabela: TDBTableControl;
  pTitulo: string): Integer;
var
  lIndice: Integer;
begin
  for lIndice := 0 to pTabela.Columns.Count - 1 do
  begin
    if pTabela.Columns[lIndice].Title.ToLower = pTitulo.ToLower then
    begin
      Result := lIndice;
      Exit;
    end;
  end;
end;

class function TUtils.GetNomeStatusAliado(pValor: Integer): string;
begin
  case pValor of
    1 : Result := 'ATIVO';
    2 : Result := 'INATIVO';
    3 : Result := 'SUSPENSO/CONGELADO'
    else Result := 'OUTROS';
  end;
end;

class function TUtils.GetNomeStatusCliente(pValor: Integer): string;
begin
  case pValor of
    1 : Result := 'ATIVO';
    2 : Result := 'INATIVO';
    4 : Result := 'BLOQUEADO';
    5 : Result := 'SERVIÇO DE PROTEÇÃO'
    else Result := 'OUTROS';
  end;
end;

class function TUtils.GetNomeStatusFornecedor(pValor: Integer): string;
begin
  case pValor of
    1 : Result := 'ATIVO';
    2 : Result := 'INATIVO';
    else Result := 'OUTROS';
  end;
end;

class function TUtils.GetNomeStatusProduto(pValor: Integer): string;
begin
  case pValor of
    1 : Result := 'ATIVO';
    2 : Result := 'INATIVO';
    3 : Result := 'BALANÇA';
    4 : Result := 'BLOQUEADO'
    else Result := 'OUTROS';
  end;
end;

class function TUtils.GetPrecoPadraoProduto(pValor: Integer): string;
begin
  case pValor of
    1 : Result := 'Custo';
    3 : Result := 'Promocional';
    4 : Result := 'Consignado';
    else  Result := 'Venda';
  end;
end;

class function TUtils.GetTokenNome(pServidor : TServidor): string;
begin
  case pServidor of
    SERVICE: Result := 'FACIL_WEB_TOKEN';
    MENSAGENS: Result := 'FACIL_MENSAGENS_TOKEN';
    WHATSAPP: Result := 'FACIL_COMUNICACAO_TOKEN';
  end;
end;

class function TUtils.IsPerfilAliado(pUsuario: TDadosUsuarioVO): Boolean;
begin
  Result := pUsuario.Perfil = Ord(TPerfil.ALIADO);
end;

class function TUtils.IsPerfilFacilSistemas(pUsuario: TDadosUsuarioVO;
  pVerificarAliado: Boolean): Boolean;
begin
  Result := pUsuario.Perfil = Ord(TPerfil.FACIL_SISTEMAS);

  if Result and pVerificarAliado then
    Result := pUsuario.Aliado = 0;
end;

class function TUtils.IsPerfilParceiro(pUsuario: TDadosUsuarioVO;
  pVerificarAliado: Boolean): Boolean;
begin
  Result := pUsuario.Perfil = Ord(TPerfil.PARCEIRO);

  if Result and pVerificarAliado then
    Result := pUsuario.Aliado = 0;
end;

class procedure TUtils.LimparErrosClass;
begin
  asm
    $('.form-text.text-muted.text-danger').hide();
    $('.form-group.has-error').removeClass('has-error');
  end;
end;

class procedure TUtils.MostrarElemento(pElementoId: string);
begin
  asm
    $('#'+ pElementoId).removeClass('d-none');
    $('#'+ pElementoId).addClass('d-block');
  end;
end;

class procedure TUtils.OcultarDivLoading;
begin
  asm
    var div = document.getElementById("gif-loading");
    div.style.display = "none";
  end;
end;

class procedure TUtils.OcultarElemento(pElementoId: string);
begin
  asm
    $('#'+ pElementoId).removeClass('d-block');
    $('#'+ pElementoId).addClass('d-none');
  end;
end;

class procedure TUtils.OpenModal(pId: string);
begin
  asm
    $('#' + pId).modal('show');
  end;
end;

class function TUtils.PossuiPermissao(pTabela: string; pPermissao : TTipoPermissao): Boolean;
var
  lJsonObject: TJSObject;
begin
  Result := False;

  if FDicionarioPermissoes.ContainsKey(pTabela) then
  begin
    lJsonObject := FDicionarioPermissoes[pTabela];

    case pPermissao of
      VISUALIZAR : Result := StrtoBool(string(lJsonObject['visualizar']));
      INSERIR : Result := StrtoBool(string(lJsonObject['inserir']));
      ALTERAR : Result := StrtoBool(string(lJsonObject['alterar']));
      EXCLUIR : Result := StrtoBool(string(lJsonObject['excluir']));
    end;
  end;
end;

class procedure TUtils.RemoverElementoPorId(pId: string);
var
  lElement: TJSHTMLElement;
begin
  lElement := TJSHTMLElement(Document.getElementById(pId));

  if Assigned(lElement) then
    lElement.remove;
end;

class procedure TUtils.RemoverErroClass(pClass: string);
var
  lIdErro,
  lDivErro : string;
begin
  lIdErro := pClass + '_error';
  lDivErro := lIdErro + '_div';
  asm
    $('#'+ lIdErro).hide();
    $('#'+ lDivErro).removeClass('has-error');
  end;
end;

class procedure TUtils.RemoverMenusVazios;
begin
  asm
    function removerVazios() {
      let algoRemovido = false;

      document.querySelectorAll('.menu_principal').forEach(function(menu) {
        let subMenus = menu.querySelectorAll('.nav-collapse li');
        if (subMenus.length === 0) {
          menu.remove();
          algoRemovido = true;
        }
      });

      // se removeu algo, chama novamente
      if (algoRemovido) removerVazios();
      }
    removerVazios();
  end;
end;

class procedure TUtils.SelecionarTab(pIdentificador: string);
begin
  asm
    var tab = new bootstrap.Tab(document.querySelector(pIdentificador));
    tab.show();
  end;
end;

class procedure TUtils.SetErroClass(pClass, pErro: string);
var
  lIdErro,
  lDivErro : string;
begin
  lIdErro := pClass + '_error';
  lDivErro := lIdErro + '_div';
  asm
    $('#'+ lIdErro).text(pErro);
    $('#'+ lIdErro).show();
    $('#'+ lDivErro).addClass('has-error');
  end;
end;

class procedure TUtils.SetMensagemDivLoading(pMensagem: string);
begin
  asm
   $('#mensagem_loading').text(pMensagem);
  end;

  MostrarElemento('mensagem_loading');
end;

class procedure TUtils.SetPaginaSelecionada;
var
  lPair: TPair<string,string>;
begin
  try
    asm
      $('li.nav-item.menu_principal.active').removeClass('active');
      $('li').removeClass('active');
      $('li').removeClass('submenu');
      $('.collapse').removeClass('show');
    end;

    for lPair in FDicionarioClassesHtml do
    begin
      asm
        $('#' + lPair.Key).addClass(lPair.Value);
      end;
    end;

  finally
    FDicionarioClassesHtml.Clear;
  end;
end;

class procedure TUtils.SetValorDicionarioClasses(pChave, pValor: string);
begin
  if not Assigned(FDicionarioClassesHtml) then
    FDicionarioClassesHtml := TDictionary<string,string>.Create;

  FDicionarioClassesHtml.Add(pChave, pValor);
end;

class function TUtils.SomenteNumeros(const pTexto: string): string;
var
  lIndice: Integer;
begin
  Result := '';

  for lIndice := 1 to Length(pTexto) do
    if pTexto[lIndice] in ['0'..'9'] then
      Result := Result + pTexto[lIndice];
end;

class function TUtils.ValidarEmail(pEmail: string): Boolean;
var
  lRegEx: TJSRegExp;
begin
  lRegEx := TJSRegExp.New('^[^\s@]+@[^\s@]+\.[^\s@]+$', 'i');
  Result := lRegEx.test(pEmail);
end;

class function TUtils.VerificarAcessoServidor(pServidor: TServidor;
  pPerfilAcesso: string): Boolean;
var
  lPerfisCadastrados : TArray<string>;
  lIndice : Integer;
  lCodigoServidor : string;
begin
  Result := False;

  lCodigoServidor := GetCodigoServidor(pServidor);

  if not(pPerfilAcesso.IsEmpty) then
  begin
    lPerfisCadastrados := SplitString(pPerfilAcesso, '|');

    for lIndice := Low(lPerfisCadastrados) to High(lPerfisCadastrados) do
    begin
      if (lPerfisCadastrados[lIndice] = lCodigoServidor) or (lPerfisCadastrados[lIndice] = '99') then
      begin
        Result := True;
        Break;
      end;
    end;
  end;
end;

end.
